// StepTwo.js
import React, { useEffect, useState } from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import { initialValuesTwo, validationSchemaTwo } from "./StepTwo.form";
import { VirtualScenes } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./SceneForm.scss";

// 2. AÑADIMOS la importación de nuestro TiptapEditor
import { TiptapEditor } from "../../../TiptapEditor/TiptapEditor";

const virtualSceneController = new VirtualScenes();

export function StepTwo({
  formData,
  updateFormData,
  nextStep,
  prevStep,
  isUpdateMode,
  scene,
}) {
  const { accessToken } = useAuth();
  const [moduleData, setModuleData] = useState(null);

  // Carga los datos del módulo en modo de actualización
  useEffect(() => {
    // La misma corrección que en StepOne: hacemos el array de dependencias seguro.
    async function fetchData() {
      if (isUpdateMode && scene?.refId) {
        try {
          const data = await virtualSceneController.getVirtualScenesModeule(
            scene.refId,
            accessToken,
            "module_02",
          );
          setModuleData(data.moduleData);
        } catch (error) {
          console.error("Error fetching module data:", error);
        }
      }
    }
    fetchData();
  }, [isUpdateMode, accessToken, scene?.refId]); // <-- ARREGLO APLICADO AQUÍ

  const formik = useFormik({
    initialValues: isUpdateMode
      ? initialValuesTwo(moduleData)
      : initialValuesTwo(formData),
    validationSchema: validationSchemaTwo(),
    validateOnChange: false,
    enableReinitialize: true,
    // Construimos la lógica de onSubmit que faltaba
    onSubmit: async (values) => {
      try {
        // Obtenemos el ID de forma segura, como en StepOne
        const _id =
          isUpdateMode && scene?.refId
            ? scene.refId
            : localStorage.getItem("idScene");

        const modulePath = "module_02";

        // Llamamos a la API para guardar los datos de este paso
        await virtualSceneController.createModuleAdd(
          modulePath,
          accessToken,
          _id,
          values,
        );
      } catch (error) {
        console.error("Error al enviar el formulario del StepTwo:", error);
        // Opcional: Mostrar un toast de error al usuario
      }

      // Actualizamos el estado del padre y avanzamos al siguiente paso
      updateFormData(values);
      nextStep();
    },
  });

  return (
    <Form className="virtual-scene-form" onSubmit={formik.handleSubmit}>
      {/* Title */}
      <Form.Input
        label="Título de la introducción"
        name="ModOneTitle"
        placeholder="Ingrese el título"
        onChange={formik.handleChange}
        value={formik.values.ModOneTitle}
        error={formik.errors.ModOneTitle}
      />

      {/* Introducción */}
      <label className="field-label">Introducción (200 caracteres max)</label>

      {/* 3. REEMPLAZAMOS el primer Editor de TinyMCE */}
      <TiptapEditor
        content={formik.values.ModOneIntroduction}
        onChange={(newContent) =>
          formik.setFieldValue("ModOneIntroduction", newContent)
        }
      />

      {/* Objetivos Didácticos */}
      <label className="field-label">Objetivos Didácticos</label>

      {/* 4. REEMPLAZAMOS el segundo Editor de TinyMCE */}
      <TiptapEditor
        content={formik.values.ModOneObjetives}
        onChange={(newContent) =>
          formik.setFieldValue("ModOneObjetives", newContent)
        }
      />

      {/* Niveles / Edades */}
      <Form.Input
        label="Niveles / Edades"
        name="ModOneLevels"
        placeholder="Ejemplo: Primaria, Secundaria, Universitario"
        onChange={formik.handleChange}
        value={formik.values.ModOneLevels}
        error={formik.errors.ModOneLevels}
      />

      <Form.Group>
        <Button
          type="button"
          onClick={prevStep}
          color="orange"
          style={{ width: "33.3333%" }}
        >
          Anterior
        </Button>
        <Button
          type="submit"
          primary
          style={{
            width: isUpdateMode ? "33.3333%" : "66.6666%",
            marginLeft: isUpdateMode ? "auto" : "33.3333%",
          }}
          loading={formik.isSubmitting}
        >
          Subir
        </Button>
        {isUpdateMode && (
          <Button
            type="button"
            onClick={nextStep}
            color="green"
            style={{ width: "33.3333%" }}
          >
            Siguiente
          </Button>
        )}
      </Form.Group>
    </Form>
  );
}
